// hooks/useImageSlider.ts
import { ref, onMounted, onUnmounted, type Ref } from 'vue'
import { useIntersectionObserver } from '@vueuse/core'

export default function useImageSlider() {
	const sliderRef = ref<HTMLElement | null>(null)
	const translateX = ref(0)
	const isIntersecting = ref(false)

	const { stop } = useIntersectionObserver(
		sliderRef,
		([{ isIntersecting: intersecting }]) => {
			isIntersecting.value = intersecting
		},
		{
			// 觀察選項
		},
	)

	const handleScroll = () => {
		if (isIntersecting.value && sliderRef.value) {
			const scrollDistance = window.scrollY
			translateX.value = scrollDistance
		}
	}

	onMounted(() => {
		window.addEventListener('scroll', handleScroll)
	})

	onUnmounted(() => {
		window.removeEventListener('scroll', handleScroll)
		stop() // 停止觀察
	})

	return { sliderRef, translateX, isIntersecting }
}
